import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";

import { SubNav } from "./subnav";
import { CategoriesDropdown } from "./subnav-categories-dropdown";

export const SubNavJiraTemplates = () => {
    const intl = useIntl();
    const productKey = "agile";

    const headerLinkText = intl.formatMessage({
        id: "jira-templates.logo-label",
        defaultMessage: "Jira Templates"
    });

    return (
        <SubNav
            productKey={productKey}
            headerLinkText={headerLinkText}
            headerLinkHref={useLocalizedHref(
                "/software/jira/templates/service-management"
            )}
            desktopLinks={[
                {
                    globalLinksKey: "categories",
                    linkText: intl.formatMessage({
                        id: "jira-templates.subnav.categories",
                        defaultMessage: "Categories"
                    }),
                    hasSubnav: true,
                    content: <CategoriesDropdown />
                }
            ]}
            mobileLinks={[
                {
                    mobileLinkKey: "subnav-links",
                    mobileLinksProps: [
                        {
                            globalLinksKey: "categories",
                            linkText: intl.formatMessage({
                                id: "jira-templates.subnav-mobile.dropdown.devops",
                                defaultMessage: "Categories"
                            }),
                            hasSubnav: true,
                            dropdownType: "categories"
                        }
                    ]
                }
            ]}
        />
    );
};
